export default __webpack_public_path__ + "static/media/Bandit's Belt of the Ritual Flame.3735e1a8.jpg";